import { HomeContent } from "../../components/home";

export default function Home() {
  return (
    <>
      <HomeContent />
    </>
  );
}
